"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NamesEnum;
(function (NamesEnum) {
    NamesEnum["SCHEDULED_PAYMENTS"] = "scheduledPayments";
    NamesEnum["PAST_DUE_INSTALLMENTS"] = "pastDueInstallments";
    NamesEnum["PAST_DUE_INVOICES"] = "pastDueInvoices";
})(NamesEnum || (NamesEnum = {}));
exports.default = NamesEnum;
//# sourceMappingURL=names.enum.js.map